import { useState } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

function AddAgent(props) {
    const [open, setOpen] = useState(false);
    const [agent, setAgent] = useState({
      agentType: 'AGENT',
      agentName: '',
      email: true,
      phone: true,
      englishSpeaking: true,
      commission: 'NONE',
      commissionRate: '',
      residential: false,
      arrivalDate: null,
      departureDate: null
  });

  // Open the modal form
  const handleClickOpen = () => {
    setOpen(true);
  };
    
  // Close the modal form 
  const handleClose = () => {
    setOpen(false);
  };

  // Save Agent and close modal form 
  const handleSave = () => {
    props.addAgent(agent);
    handleClose();
  }

  const handleChange = (event) => {
    setAgent({...agent, [event.target.name]: event.target.value});
  }
  
  return(
    <div>
      <IconButton onClick={handleClickOpen}><AddIcon color="primary"/></IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>New Agent</DialogTitle>
        <DialogContent>
        <Stack spacing={2} mt={1}>
          <FormControl>
            <InputLabel id="englishSpeaking">English Speaking?</InputLabel>
            <Select
              labelId="englishSpeaking-label"
              id="englishSpeaking"
              name="englishSpeaking"
              value={agent.englishSpeaking}
              onChange={handleChange}
              >
                <MenuItem value="true">true</MenuItem>
                <MenuItem value="false">false</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel id="commissionType">Commission Type</InputLabel>
            <Select
              labelId="commission-label"
              id="commission"
              name="commission"
              value={agent.commission}
              onChange={handleChange}
              >
                <MenuItem value="GROSS">GROSS</MenuItem>
                <MenuItem value="NET">NET</MenuItem>
                <MenuItem value="NONE">NONE</MenuItem>
            </Select>
          </FormControl>
          <TextField label="commissionRate" name="commissionRate" 
            variant="standard" type="number" value={agent.commissionRate} 
            onChange={handleChange}/> 
          <TextField label="notes" name="notes" 
            variant="standard" value={agent.notes} 
            onChange={handleChange}/> 
        </Stack>
        </DialogContent>
        <DialogActions>
           <Button onClick={handleClose}>Cancel</Button>
           <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>            
    </div>
    );
}

export default AddAgent;